import React, { Component } from "react";
import { Permissions } from "services/permissions";
import { BloxButton } from "styled_components/Common/BloxButton";
import { RadioCheckBox } from "styled_components/Common/RadioCheckBox";
import { SuccessMessage, ErrorMessage } from "utils/CommonConstants";
import ScrollView from "sub_components/Common/BloxScrollViewNew";
import { sortModules } from "utils/SupportUtils";

class PermissionSelector extends Component {
  constructor(props) {
    super(props);
    this.state = {
      originalPages: null,
      updatedPages: null,
      updates: [],
      loggedInUsersRole: null,
      usersMemberships: null,
      moduleUpdates: [],
      servicesToDisplay: null,
      selectedPage: null,
    };
  }
  checkAccess = (componentName, pageName) => {
    const { pages } = this.props;

    return Permissions.checkComponentAccessPermssions(
      pages,
      pageName,
      componentName
    );
  };
  getServiceId = (module) => {
    switch (module) {
      case "Account":
        return 3;
      case "Support":
        return 2;
      case "Billing":
        return 4;
      case "Storage":
        return 1;
      default:
        return 0;
    }
  };

  addToUpdates = (component, page, access) => {
    const { updates } = this.state;
    const { selectedModule, selectedId } = this.props;

    if (updates.some((e) => e.componentName === component)) {
      const componentIndex = updates.findIndex(
        (x) => x.componentName === component
      );
      this.setState(
        // eslint-disable-next-line
        (state) => (state.updates[componentIndex].access = access)
      );
    } else {
      const newUpdates = [...updates];
      const serviceId = this.getServiceId(selectedModule);
      newUpdates.push({
        componentName: component,
        pageId: page[0]?.id,
        access,
        serviceId,
        userId: selectedId,
      });
      this.setState({ updates: newUpdates });
    }
  };
  captureChange = (component, page, components) => {
    const { updatedPages } = this.state;
    const pageIndex = updatedPages.findIndex(
      (x) => x.displayName === page[0]?.displayName
    );
    const componentIndex = components.findIndex((x) => x.name === component);
    const currentAccess =
      updatedPages[pageIndex].components[componentIndex].access;
    let updatedAccess = null;
    if (currentAccess > 0) {
      updatedAccess = "0000";
    } else {
      updatedAccess = "1111";
    }
    this.setState(
      // eslint-disable-next-line
      (state) =>
        // eslint-disable-next-line
        (state.updatedPages[pageIndex].components[componentIndex].access =
          updatedAccess),
      () => {
        this.addToUpdates(component, page, updatedAccess);
      }
    );
  };
  captureModuleChange = (serviceName, currentAccess) => {
    const { servicesToDisplay } = this.state;
    const { setModalContent } = this.props;
    setModalContent("CLOSE");
    const serviceIndex = servicesToDisplay.findIndex(
      (x) => x.displayName === serviceName
    );

    let updatedAccess = null;
    if (currentAccess > 0) {
      updatedAccess = "0000";
    } else {
      updatedAccess = "1111";
    }

    this.setState(
      // eslint-disable-next-line
      (state) => (state.servicesToDisplay[serviceIndex].access = updatedAccess),
      () => {
        this.addToModuleUpdates(this.getServiceId(serviceName), updatedAccess);
      }
    );
  };
  addToModuleUpdates = (serviceId, updatedAccess) => {
    const { organizationId } = this.props;
    const { moduleUpdates } = this.state;
    const enabled = updatedAccess === "0000" ? false : true;
    if (moduleUpdates.some((e) => e.serviceId === serviceId)) {
      const componentIndex = moduleUpdates.findIndex(
        (x) => x.serviceId === serviceId
      );
      this.setState(
        // eslint-disable-next-line
        (state) => (state.moduleUpdates[componentIndex].access = updatedAccess)
      );
    } else {
      const newUpdates = [...moduleUpdates];
      newUpdates.push({
        organizationId,
        serviceId,
        subPages: true,
        enabled,
        access: updatedAccess,
      });

      this.sendUpdatedModulePermissions(newUpdates);
    }
  };

  renderPermissions = (selectedPage, hasUserPermissionEditAccess) => {
    const { updatedPages } = this.state;
    const { user } = this.props;
    const page =
      updatedPages &&
      updatedPages.filter((page) => page?.displayName === selectedPage);
    let components = page[0]?.components;
    components = sortModules(components);

    return (
      components &&
      components.map((component) => {
        const hasDisplayName =
          component.displayName !== null && component.displayName !== ""
            ? true
            : false;
        return (
          hasDisplayName && (
            <div className="permission-container">
              <div
                className={
                  hasUserPermissionEditAccess && user?.role !== "owner"
                    ? "permission-toggle"
                    : "permission-toggle no-pointer"
                }
              >
                <RadioCheckBox
                  checked={this.checkAccess(
                    component.name,
                    page[0]?.displayName
                  )}
                  id={component.name}
                  onClickFunc={
                    hasUserPermissionEditAccess
                      ? () => {
                          this.captureChange(
                            component.name,
                            page,
                            components,
                            this.checkAccess(component.name, page.displayName)
                          );
                        }
                      : () => {}
                  }
                />
              </div>
              <div className="description body10">{component.displayName}</div>
            </div>
          )
        );
      })
    );
  };

  setSelectedPage = (page) => {
    this.setState({ selectedPage: page });
  };

  renderPages = (pages) => {
    const { selectedPage } = this.state;

    return pages.map((page, index) => {
      const pageComponents = page.components;
      const pageName = page.displayName;
      if (!selectedPage && index === 0 && pageName) {
        this.setSelectedPage(pageName);
      }

      return (
        pageComponents.length !== 0 && (
          <div
            className={
              selectedPage === page?.displayName
                ? "page-container selected"
                : "page-container"
            }
          >
            <div
              className="page-title-wrapper"
              onClick={() => this.setSelectedPage(pageName)}
              data-cy={`permission-page-${index}`}
            >
              <div className="page-title heading60">{page.displayName}</div>
            </div>
          </div>
        )
      );
    });
  };
  setInitialPages = (pages) => {
    this.setState({
      originalPages: pages,
      updatedPages: pages,
      selectedPage: null,
    });
  };
  componentDidMount() {
    const { pages, user, organizationId } = this.props;
    this.setInitialPages(pages);

    if (organizationId) {
      this.getUsersRole(organizationId);
    }
    if (user && organizationId) {
      this.getUsersMemberships(organizationId);
    }
  }
  componentDidUpdate(prevProps) {
    const { pages, organizationId, user } = this.props;

    if (pages !== prevProps.pages) {
      this.setInitialPages(pages);
    }
    if (prevProps.organizationId !== organizationId) {
      this.getUsersRole(organizationId);
    }
    if (prevProps.user !== user) {
      this.getUsersMemberships(organizationId);
    }
  }
  getUsersRole = (id) => {
    const { auth_status } = this.props;
    const { role } = this.state;
    const { memberships = {} } = auth_status;
    const currentMembershipSelected = memberships.filter(
      (membership) => Number(membership.organizationId) === Number(id)
    );
    if (currentMembershipSelected[0].role !== role) {
      this.setState({ loggedInUsersRole: currentMembershipSelected[0].role });
    }
  };
  getUsersMemberships = async (id) => {
    const { user } = this.props;

    if (id && user) {
      const response = await Permissions.getUserMemberships(user?.id, id);
      if (response.data) {
        this.setState({ usersMemberships: response.data[0] }, () => {
          this.setServices(response.data[0]);
        });
      }
    }
  };
  setServices = (usersMemberships) => {
    const services = usersMemberships?.services || [];

    let servicesToDisplay = [];
    const activeServices = [];
    const inactiveServices = [];

    if (services.length !== 0) {
      services.filter(
        (service) =>
          service?.active === true && activeServices.push(service.displayName)
      );
      services.filter(
        (service) =>
          service?.active === false &&
          inactiveServices.push(service.displayName)
      );
      activeServices.forEach((service) =>
        servicesToDisplay.push({ displayName: service, access: "1111" })
      );
      inactiveServices.forEach((service) =>
        servicesToDisplay.push({ displayName: service, access: "0000" })
      );
    }

    servicesToDisplay = sortModules(servicesToDisplay);

    this.setState({ servicesToDisplay });
  };

  setSelectedModule = (module) => {
    const { callback } = this.props;

    callback(module);
  };
  setConfirmationModal = (displayName, access) => {
    const { setModalContent } = this.props;

    const type = access !== "0000" ? "remove" : "add";
    const headerText = `ARE you sure you want to ${type} ${displayName} access for this user ?`;

    const button = (
      <BloxButton
        className="buttons41"
        id="continue"
        text="Yes"
        module="storage"
        enabled={true}
        onClick={() => this.captureModuleChange(displayName, access)}
        cypressId="okay"
      />
    );

    setModalContent(false, headerText, button);
  };

  renderServices = () => {
    const { selectedModule } = this.props;

    const uniqueServices = [
      { displayName: "Account" },
      { displayName: "Billing" },
      { displayName: "Support" },
      { displayName: "Storage" },
    ];

    return uniqueServices.map((service) => (
      <div
        className={
          selectedModule === service?.displayName
            ? "service-container selected"
            : "service-container"
        }
        onClick={() => this.setSelectedModule(service?.displayName)}
      >
        <div className="description body10">{service.displayName}</div>
      </div>
    ));
  };
  sendUpdatedModulePermissions = async (updates) => {
    const {
      setModalContent,
      usersRole,
      reloadPermissions,
      selectedModule,
      user,
    } = this.props;

    const params = { updates, usersRole };

    const response = await Permissions.updateModulePermissions(
      params,
      user?.id
    );
    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="account"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );
    if (response && !response.data.error) {
      setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
      reloadPermissions(selectedModule);
    } else {
      setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
    }
  };

  sendUpdatedPermissions = async () => {
    const {
      setModalContent,
      reloadPermissions,
      selectedModule,
      organizationId,
      auth_status: {
        user: { id },
      },
    } = this.props;
    const { updates } = this.state;
    const params = { updates, organizationId, createdBy: id };
    const response = await Permissions.updateComponentPermissions(params);
    const button = (
      <BloxButton
        className="buttons41"
        id="okay"
        text="OKAY"
        module="account"
        enabled={true}
        onClick={() => {}}
        cypressId="okay"
      />
    );
    if (response && !response.data.error) {
      setModalContent("TIMEOUT_CLOSE", SuccessMessage, button);
      reloadPermissions(selectedModule);
      this.setState({ updates: [] });
    } else {
      setModalContent("TIMEOUT_CLOSE", ErrorMessage, button);
    }
  };

  isUserCreatedInLast24Hours = () => {
    const { user } = this.props;
    const currentTime = new Date();
    const creationTime = new Date(user?.creation_date);
    const timeDifference = currentTime - creationTime;
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    return hoursDifference <= 24;
  };

  render() {
    const { updatedPages, servicesToDisplay, selectedPage } = this.state;
    const {
      user,
      error,
      module,
      hasUserPermissionEditAccess,
      pagesLoaded,
      selectedModule,
    } = this.props;
    const hasPermissions =
      updatedPages && updatedPages.length > 0 ? true : false;
    const service =
      servicesToDisplay &&
      servicesToDisplay.filter(
        (service) => service?.displayName === selectedModule
      );
    const isNewUser =
      selectedModule === "Support" ? this.isUserCreatedInLast24Hours() : false;

    return (
      <div className="permission-selector-container">
        <div className="side-details">
          <div className="module-permission-container">
            <div>{user && servicesToDisplay && this.renderServices()}</div>
          </div>
        </div>
        <div className="main-selection">
          <div className="divider"></div>
          <div className="page-container-wrapper" id="page-container-wrapper">
            {updatedPages && !isNewUser && this.renderPages(updatedPages)}
            {isNewUser && <div className="body10">New User</div>}
            {!hasPermissions && pagesLoaded && (
              <div className="body10">
                User setup incomplete please contact support.
              </div>
            )}
          </div>
          <div className="divider"></div>
          <ScrollView>
            <div className="page-permissions-wrapper">
              <>
                {selectedPage &&
                  updatedPages &&
                  !isNewUser &&
                  this.renderPermissions(
                    selectedPage,
                    hasUserPermissionEditAccess
                  )}
              </>
              {isNewUser && (
                <div className="body10">
                  For new users the support section will be enabled in 24 hours.
                </div>
              )}
              {hasUserPermissionEditAccess && !hasPermissions && (
                <div className="edit-modules-button">
                  <BloxButton
                    className="buttons41"
                    id="update-module-button"
                    text={`Add ${selectedModule}`}
                    module={module}
                    enabled={true}
                    onClick={() =>
                      this.setConfirmationModal(
                        service[0]?.displayName,
                        service[0]?.access
                      )
                    }
                    cypressId="add-module"
                  />
                </div>
              )}
            </div>
          </ScrollView>
          {!updatedPages && error && (
            <div className="pages-error body10">{error}</div>
          )}
          {hasUserPermissionEditAccess &&
            user?.role !== "owner" &&
            hasPermissions &&
            !isNewUser && (
              <div className="update-permissions-button">
                <div className="divider"></div>
                <div className="buttons">
                  {service && service[0]?.displayName !== "Account" && (
                    <BloxButton
                      className="buttons41"
                      id="update-module-button"
                      text={`Remove ${selectedModule}`}
                      module={module}
                      enabled={true}
                      onClick={() =>
                        this.setConfirmationModal(
                          service[0]?.displayName,
                          service[0]?.access
                        )
                      }
                      cypressId="remove-module"
                    />
                  )}
                  <BloxButton
                    className="buttons41"
                    id="save-permissions-button"
                    text="Save"
                    module={module}
                    enabled={true}
                    onClick={this.sendUpdatedPermissions}
                    cypressId="permissions-update"
                  />
                </div>
              </div>
            )}

          {!hasUserPermissionEditAccess && (
            <div className="update-permissions-button body10">
              You do not have permission to edit.
            </div>
          )}
          {user?.role === "owner" && (
            <div className="update-permissions-button body10">
              You can view but not edit another owners permissions.
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default PermissionSelector;
